import React from 'react';
import { Text } from '@spotify-internal/encore-web';
import type { LibraryImporterModule as LibraryImporterModuleData } from '../../types/referrals';
import styles from './LibraryImporterModule.module.scss';

type LibraryImporterModuleProps = {
  libraryImporterModule: LibraryImporterModuleData;
};

export function LibraryImporterModule({
  libraryImporterModule,
}: LibraryImporterModuleProps) {
  return (
    <section className={styles.section}>
      <div className={styles.textContent}>
        <Text variant="titleLarge" as="h2" className={styles.title}>
          {libraryImporterModule.title}
        </Text>
        <Text variant="bodyMedium" className={styles.subtitle}>
          {libraryImporterModule.subtitle}
        </Text>
      </div>
      <img
        className={styles.image}
        src={libraryImporterModule.imageUrl}
        alt=""
        role="presentation"
      />
    </section>
  );
}
